import { RouteConfig } from 'vue-router'
import { Location } from '../models'

/*** Permissions ***/
import { DashboardRouteNames } from '@/routes/constants/location'
// import TeamSettingsPage from '@/pmd/pages/settings/TeamSettingsPage.vue';
import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import MediaSettings from '@/pmd/pages/medias/MediaSettings.vue'
import { Modules } from '../util/modules'
// media files
import { locationRoutes } from '@/routes/location/'

import { locationSettingsRouteNames } from '@/routes/constants/location'
import { locationSettingsRoute } from '@/routes/location/settings'
import store from '../store'
import { _requireAccessLevelAndLocation, requireAuthAndLocation } from './auth'

// ====================================================== //
// ========================================================== //
/*** Agency Level Settings Components: ***/

const ProfileSettingsV2 = () => import('@/pmd/pages/settings/Profile.vue').then(m => m.default)

// ====================================================== //
/*** Report Adwords Components: ***/

// ========================================================== //
/*** Location Level Components: ***/
// const SideBar = () => import("@/pmd/components/locations/LocationSideBar.vue").then(m => m.default)
const LocationParent = () => import(/* webpackChunkName: "location" */ '@/pmd/pages/LocationParent.vue')

const CustomObjectsPage = () =>
  import(/* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectsPage.vue')

const CreateCustomObjectModal = () =>
  import(/* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CreateCustomObject.vue')

const CustomObjectSchemaInfo = () =>
  import(/* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectSchemaInfo.vue')

const CustomObjectSchemaDetails = () =>
  import(/* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectSchemaDetails.vue')

const CustomObjectAssociations = () =>
  import(/* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/CustomObjectAssociations.vue')

const ConfigureAddRecordModal = () =>
  import(/* webpackChunkName: "custom-objects" */ '@/pmd/pages/CustomObjects/ConfigureAddRecordModal.vue')

const CustomerImportsPage = () =>
  import(/* webpackChunkName: "customer-imports" */ '@/pmd/pages/customers/ContactBulkRequests.vue')

const CustomerRestore = () => import('@/pmd/pages/contact/RestorePage.vue')

// ========================================================== //
/*** Location Level Settings Components: ***/

const CRMSettings = () =>
  import(/* webpackChunkName: "location-pipeline-settings" */ '@/pmd/pages/settings/CRMSettings.vue').then(
    m => m.default
  )

const AppointmentWidgetSettings = () =>
  import(/* webpackChunkName: "location-appointment-settings" */ '@/pmd/pages/settings/AppointmentWidgetSettings.vue')
const ChatWidgetSettings = () =>
  import(/* webpackChunkName: "location-chat-settings" */ '@/pmd/pages/settings/ChatWidgetSettings.vue').then(
    m => m.default
  )
const NoShowSMSSettings = () =>
  import(/* webpackChunkName: "location-nosms-settings" */ '@/pmd/pages/settings/NoShowSMSSettings.vue').then(
    m => m.default
  )
const BirthdaySMSSettings = () =>
  import(/* webpackChunkName: "location-birthday-sms-settings" */ '@/pmd/pages/settings/BirthdaySMSSettings.vue').then(
    m => m.default
  )

const TemplateSettings = () =>
  import(/* webpackChunkName: "location-template-settings" */ '@/pmd/pages/settings/TemplateMessageSettings.vue')

const QrCodePage = () =>
  import(/* webpackChunkName: "m-qr-code" */ '@/pmd/pages/marketing/QrCodePage.vue').then(m => m.default)

const MediaSettings = () => import(/* webpackChunkName: "media-center" */ '@/pmd/pages/medias/MediaFiles.vue')

const ElizaFAQSetting = () =>
  import(/* webpackChunkName: "bot-faq" */ '@/pmd/pages/agency/ElizaFAQSetting.vue').then(m => m.default)

const WordpressAppIndexPage = () =>
  import(/* webpackChunkName: "wordpress-dashboard" */ '@/pmd/pages/wordpress/WordpressAppIndexPage.vue')

export const v2: RouteConfig[] = [
  {
    path: '/v2/location/:location_id?',
    name: 'location-v2',
    component: LocationParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'crm-settings',
        name: 'crm-settings',
        component: CRMSettings,
        beforeEnter: _requireAccessLevelAndLocation,
      },
      {
        path: 'wordpress',
        name: 'wordpress-v2',
        meta: { translations: [Modules.Wordpress] },
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'wordpress/:component',
        name: 'wordpress-v2',
        meta: { translations: [Modules.Wordpress] },
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'wordpress/:wpId/:component',
        name: 'wordpress-v2',
        meta: { translations: [Modules.Wordpress] },
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'wordpress/:pathMatch(.*)*',
        name: 'wordpress-v2',
        meta: { translations: [Modules.Wordpress] },
        component: WordpressAppIndexPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'funnels-websites/wordpress/*',
        redirect: 'wordpress',
      },
      {
        path: 'media-storage',
        name: 'media-settings-v2',
        component: MediaSettings,
        beforeEnter: requireAuthAndLocation,
        meta: {
          router_version: 'v2',
          hideTopBar: true,
        },
      },
      {
        path: 'settings',
        name: locationSettingsRouteNames.setting.default,
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          ...locationSettingsRoute,

          {
            path: 'settings-profile',
            name: locationSettingsRouteNames.setting.profileSettings,
            component: ProfileSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'profile',
            name: locationSettingsRouteNames.setting.profile,
            component: ProfileSettingsV2,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'noshow_sms',
            name: locationSettingsRouteNames.setting.noShowSMS,
            component: NoShowSMSSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'birthday_sms',
            name: locationSettingsRouteNames.setting.birthdaySMS,
            component: BirthdaySMSSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'chat_widget',
            name: locationSettingsRouteNames.setting.chatWidget,
            component: ChatWidgetSettings,
            beforeEnter: requireAuthAndLocation,
            meta: { translations: [Modules.ChatWidgetBuilder] },
          },
          {
            path: 'appointment_widget',
            name: locationSettingsRouteNames.setting.appointmentWidget,
            component: AppointmentWidgetSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'templates',
            name: locationSettingsRouteNames.setting.templateSettings,
            component: TemplateSettings,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'objects',
            name: locationSettingsRouteNames.setting.customObjects.default,
            component: CustomObjectsPage,
            beforeEnter: requireAuthAndLocation,
            children: [
              {
                path: 'create',
                name: locationSettingsRouteNames.setting.customObjects.create,
                component: CreateCustomObjectModal,
              },
            ],
          },
          {
            path: 'objects/:customObjectId',
            name: locationSettingsRouteNames.setting.customObjectSchema.default,
            component: CustomObjectSchemaInfo,
            children: [
              {
                path: 'details',
                name: locationSettingsRouteNames.setting.customObjectSchema.details,
                component: CustomObjectSchemaDetails,
              },
              {
                path: 'associations',
                name: locationSettingsRouteNames.setting.customObjectSchema.associations,
                component: CustomObjectAssociations,
              },
              {
                path: 'customize-record-modal',
                name: locationSettingsRouteNames.setting.customObjectSchema.customizeRecordModal,
                component: ConfigureAddRecordModal,
              },
            ],
          },
          {
            path: 'eliza_faq',
            name: locationSettingsRouteNames.setting.elizaFaq,
            component: ElizaFAQSetting,
            beforeEnter: async (to, from, next) => {
              const location = await Location.getById(to.params.location_id)
              store
                .dispatch('auth/get')
                .then(() => {
                  if (location && !location.botService)
                    next({
                      name: DashboardRouteNames.default,
                      replace: true,
                      params: { location_id: to.params.location_id },
                    })
                  next()
                })
                .catch(() => {
                  next()
                })
            },
          },
        ],
      },
      {
        path: 'settings/qr-codes',
        redirect: 'qr-codes',
      },
      {
        path: 'qr-codes/*',
        redirect: 'qr-codes',
      },
      {
        path: 'qr-codes',
        name: 'qr-codes',
        component: QrCodePage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'settings/conversation-ai-v2/:catchAll(.*)*',
        name: 'conversation-ai-v2',
        beforeEnter: requireAuthAndLocation,
        redirect: (to: any) => {
          return {
            path: `v2/location/${to.params.location_id}/ai-agents/conversation-ai/${to.params.catchAll || ''}`,
            params: to.params,
            query: to.query,
            hash: to.hash,
          }
        },
      },
      ...locationRoutes,
    ],
  },
]
